<template>
  <div :class="{ uWhite: isTablet || isMobile }">
    <a v-if="referrerCheck" class="c-bannerFixed js-banner" :href="`/kodate/${validateKindPath(propData.kind)}area/${storedLocation.pref.code}/${storedLocation.city.code}/`">
      {{storedLocation.city.name}}にある、その他{{validateKind(propData.kind)}}はこちらからご覧いただけます。
      <img width="28" height="28" src="@/assets/arrow-circle.png" alt="">
    </a>

    <div class="c-slider">
      <div class="c-slider__main">
        <img class="c-slider__item c-slider__item__img js-slider" width="375" height="260" :src="imageRender(propData.image,propData.priority, mode)" alt="">
        <school-area-google-map class="c-slider__item" :center="coordinate" :makerList="markers" :zoom="zoom" />

        <span class="c-slider__arrow c-slider__arrow--prev" @click="onClickSlider(slider)"></span>
        <span class="c-slider__arrow c-slider__arrow--next" @click="onClickSlider(slider)"></span>
      </div>

      <div class="c-slider__thumbnail">
        <div class="c-slider__thumbnailItem" :class="{'c-slider__thumbnailItem--active': slider}" @click="onClickSlider(false)">
          <img class="c-slider__thumbnailImage" :src="imageRender(propData.image,propData.priority)" alt="">
        </div>
        <div class="c-slider__thumbnailItem" :class="{'c-slider__thumbnailItem--active': !slider}" @click="onClickSlider(true)">
          <img class="c-slider__thumbnailImage" src="@/assets/images/sample-map.png" alt="">
        </div>
      </div>
    </div>
    <p v-if="isMobile" class="c-attention">※地図上に表示されているマークは、物件がその付近住所に所在することを表すものであり、実際の物件所在地とは異なる場合があります。</p>


    <h2 class="c-pageTitle">
      <span class="c-pageTitle__label">{{validateKind(propData.kind)}}</span>
      <span class="c-pageTitle__name">{{validateText(propData.name)}}</span>
    </h2>

    <div class="c-info">
      <div class="c-info__content">
        <div class="c-info__item">
          <span class="c-info__head">所在地</span>
          <p class="c-info__data">{{validateText(propData.address)}}</p>
        </div>
        <div class="c-info__item">
          <span class="c-info__head">交通</span>
          <p class="c-info__data">{{validateText(propData.access[0].name)}}</p>
        </div>
        <div class="c-info__item">
          <span class="c-info__head">価格</span>
          <p class="c-info__data c-info__data--big">{{validateText(propData.price)}}</p>
        </div>
        <div class="c-info__item">
          <span class="c-info__head">土地面積</span>
          <p class="c-info__data">
            <common-area-changer
              :val="validateText(propData.land_area)"
              :size="13"
            />
          </p>
        </div>
        <div class="c-info__item">
          <span class="c-info__head">建物面積</span>
          <p class="c-info__data">
            <common-area-changer
              :val="validateText(propData.building_area)"
              :size="13"
            />
          </p>
        </div>
        <div class="c-info__item">
          <span class="c-info__head">間取り</span>
          <p class="c-info__data">{{validateText(layout)}}</p>
        </div>
      </div>

          <div class="c-info__action">
            <div>
              <div class="c-info__actionButtonWrap">
                <common-button
                  v-if="propData.priority > 1 && this.propData.contact_tel"
                  :title="propPhone"
                  :type="'link'"
                  :link_url="`tel:${propPhone}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon_phone_call'" />
                <common-button
                  v-if="propData.priority > 1"
                  :title="'資料請求する'"
                  :type="'link'"
                  :link_url="`/document-request/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon-mail'"
                  :label="'無料'" />
                <common-button
                  :title="'見学予約する'"
                  :type="'link'"
                  :link_url="`/reservation/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :icon="'icon-calendar-red'"
                  :label="'無料'" />
                <img
                  v-if="isBalloon"
                  class="c-info__balloon"
                  :src="require('@/assets/images/balloon/fav.png')"
                />
                <common-button
                    v-if="!isAdded"
                    :title="'お気に入りに追加'"
                    :link_url="`/reservation/${propData.id}`"
                    :large="true"
                    :width="'100%'"
                    :font_size="'14px'"
                    :callback="toggleFavorite"
                    :attr=[]
                    :border_red_text_black="true"
                    :color_red_text="true"
                    :icon="'icon-favorite'" />
                <common-button
                  v-else
                  :title="'お気に入りに済み'"
                  :link_url="`/reservation/${propData.id}`"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :callback="toggleFavorite"
                  :attr=[]
                  :icon="'favorite-selected'" />
                <common-button
                  v-if="!this.propData.contact_tel"
                  class="u-mB10"
                  :title="'掲載元のページに移動'"
                  :type="'link'"
                  :link_url="propData.url"
                  :large="true"
                  :width="'100%'"
                  :tablet_width="true"
                  :font_size="'14px'"
                  :icon="'icon-external-link-grey'"
                  :target_blank="true" />
              </div>

            </div>
            <div class="c-info__date">
              <p class="c-info__dateText">情報提供日：{{validateDate(propData.provided_at,'YYYY年MM月DD日')}}</p>
              <p class="c-info__dateText">次回更新日：情報提供より14日以内に更新</p>
            </div>
          </div>
    </div>

    <div class="c-imageArea u-dPC">
      <img class="c-imageArea__item" width="440" height="330" :src="imageRender(propData.image,propData.priority, mode)" alt="">
      <school-area-google-map class="c-imageArea__item" width="440" height="330" :center="coordinate" :makerList="markers" :zoom="zoom" />
    </div>

    <p v-if="!isMobile" class="c-attention">※地図上に表示されているマークは、物件がその付近住所に所在することを表すものであり、実際の物件所在地とは異なる場合があります。</p>
    <section v-if="storedLocation" class="c-section u-mT50">
      <h3 class="c-heading u-mB16">同じ市区郡の{{validateKind(propData.kind)}}を見る</h3>
      <a :href="`/kodate/${validateKindPath(propData.kind)}area/${storedLocation.pref.code}/${storedLocation.city.code}/`">{{storedLocation.city.name}}</a>
    </section>
    <section v-if="storedLocation" class="c-section">
      <h3 class="c-heading u-mB16">同じ都県の{{validateKind(propData.kind)}}を見る</h3>
      <a :href="`/kodate/${validateKindPath(propData.kind)}area/${storedLocation.pref.code}/`">{{storedLocation.pref.name}}</a>
    </section>
    <section class="c-section">
      <h3 class="c-heading u-mB16">物件詳細</h3>
      <dl class="c-table">
        <dt class="c-table__head">物件名</dt>
        <dd class="c-table__data">{{validateText(propData.name)}}</dd>
        <dt class="c-table__head">用途地域</dt>
        <dd class="c-table__data">{{validateText(propData.regulation_of_area)}}</dd>
        <dt class="c-table__head">価格</dt>
        <dd class="c-table__data">{{validateText(propData.price)}}</dd>
        <dt class="c-table__head">現況</dt>
        <dd class="c-table__data">{{validateKind(propData.kind)}}</dd>
        <dt class="c-table__head">販売戸数</dt>
        <dd class="c-table__data">{{validateText(propData.amount)}}</dd>
        <dt class="c-table__head">土地権利</dt>
        <dd class="c-table__data">{{validateText(propData.land_title)}}</dd>
        <dt class="c-table__head">交通</dt>
        <dd class="c-table__data">
          <p v-for="(item, index) in propData.access" :key="index">{{item.name}}</p>
        </dd>
        <dt class="c-table__head">取引態様</dt>
        <dd class="c-table__data">{{validateText(propData.contact_type)}}</dd>
        <dt class="c-table__head">私道負担・道路</dt>
        <dd class="c-table__data">{{validateText(propData.driveway)}}</dd>
        <dt class="c-table__head">その他制限事項</dt>
        <dd class="c-table__data">{{validateText(propData.restriction)}}</dd>
        <dt class="c-table__head">建ぺい率・容積率</dt>
        <dd class="c-table__data">{{validateText(propData.ratio)}}</dd>
        <dt class="c-table__head">その他概要・特記事項</dt>
        <dd class="c-table__data">{{validateText(propData.note)}}</dd>
        <dt class="c-table__head">構造・工法</dt>
        <dd class="c-table__data">{{validateText(propData.building_method)}}</dd>
        <dt class="c-table__head">完成時期</dt>
        <dd class="c-table__data">{{validateText(propData.built_at_within)}}</dd>
        <dt class="c-table__head">間取り/間取り詳細</dt>
        <dd class="c-table__data">{{validateText(layout)}}</dd>
        <dt class="c-table__head">接道・道路幅員</dt>
        <dd class="c-table__data">{{validateText(propData.adjacent_road_status)}}</dd>
        <dt class="c-table__head">土地面積</dt>
        <dd class="c-table__data">
          <common-area-changer
            :val="validateText(propData.land_area)"
            :size="13"
          />
        </dd>
        <dt class="c-table__head">情報提供日</dt>
        <dd class="c-table__data">{{validateDate(propData.provided_at,'YYYY年MM月DD日')}}</dd>
        <dt class="c-table__head">建物面積</dt>
        <dd class="c-table__data">
          <common-area-changer
            :val="validateText(propData.building_area)"
            :size="13"
          />
        </dd>
        <dt class="c-table__head">次回更新日</dt>
        <dd class="c-table__data">情報提供より14日以内に更新</dd>
      </dl>
    </section>

    <section class="c-section">
      <h3 class="c-heading u-mB16">会社情報</h3>
      <p class="c-text">{{validateText(propData.contact_name)}}</p>
      <p class="c-text">TEL : {{validateText(propPhone)}}</p>
      <p class="c-text">{{validateText(propData.contact_license)}}</p>
      <p class="c-text">{{validateText(propData.contact_address)}}</p>
      <p v-if="propData.contact_organization !== undefined" class="c-text">{{validateText(propData.contact_organization)}}</p>
    </section>
  </div>
</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import isMobile from '@/plugins/isMobile';
import Meta from '@/plugins/mixin-meta';
import SchoolAreaGoogleMap from '@/components/parts/SchoolAreaGoogleMap';
import CommonAreaChanger from '@/components/parts/CommonAreaChanger';
import CommonButton from '@/components/parts/button/CommonButton';
import dayjs from 'dayjs';

dayjs.locale('ja');
const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
export default {
  name: 'KodateContents',
  mixins: [MixinUtil, isMobile, Meta, BehaviorLogMixin],
  props: ['propData', 'referrerCheck'],
  components: {
    SchoolAreaGoogleMap,
    CommonAreaChanger,
    CommonButton,
  },
  data() {
    return {
      coordinate: null,
      markers: [],
      slider: true,
      isAdded: false,
      isBalloon: false,
      isReady: false,
      isMapReady: false,
      zoom: 13,
      mode: 'prod',
    };
  },
  computed: {
    storedFavorite() {
      return this.$store.getters['getFavorite'];
    },
    storedLocation() {
      return this.$store.getters['getLocation'];
    },
    layout() {
      return this.propData.layout.replace(',', '〜');
    },
    propPhone() {
      return this.propData.contact_tel ? this.propData.contact_tel : this.propData.contact_phone;
    },
  },
  async mounted() {
    if (query.zoom !== undefined) this.zoom = parseInt(query.zoom, 10);
    if (query.mode !== undefined) this.mode = query.mode;
    // console.log(this.propData.name);
    this.metaSetForDetail(this.storedLocation.pref.name, this.storedLocation.city.name, this.propData);
    // 地図セット
    this.markers.push(
      { position:
        {
          lat: this.propData.location.latitude,
          lng: this.propData.location.longitude,
        },
      title: 'marker_1',
      },
    );
    this.coordinate = {
      lat: this.propData.location.latitude,
      lng: this.propData.location.longitude,
    };
    // fav
    this.list = this.storedFavorite.data;
    if (this.list === null) this.list = [];
    if (this.list.length > 0) this.isAdded = this.list.find(n => n.id.toString() === this.propData.id.toString()) !== undefined;

    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
    this.displayBanner();
  },
  methods: {
    validateText(v, esc = '-') {
      return v !== undefined ? v : esc;
    },
    validateDate(val) {
      return dayjs(val).format('YYYY年MM月DD日');
    },
    validateKind(v) {
      return v === 'newly-house' ? '新築一戸建て' : '中古一戸建て';
    },
    validateKindPath(v) {
      let ret = '';
      if (v === 'newly-house') {
        ret = 'shinchiku/';
      } else if (v === 'second-hand-house') {
        ret = 'chuko/';
      }
      return ret;
    },
    onClickSlider(direction) {
      if (direction) document.querySelector('.js-slider').style.marginLeft = '-100%';
      else document.querySelector('.js-slider').style.marginLeft = '0';
      this.slider = !this.slider;
    },
    toggleFavorite() {
      this.list = this.storedFavorite;
      if (this.list === null) this.list = [];
      if (!this.isAdded) {
        this.addWishList({
          id: this.propData.id,
          pageName: this.propData.name,
          oldPriceMin: +this.propData.price_min,
          oldPriceMax: +this.propData.price_max,
        });
        this.isBalloon = true;
        this.isAdded = true;
        setTimeout(() => {
          this.isBalloon = false;
        }, 3000);
      } else {
        this.deleteWishList(this.propData.id);
        this.isAdded = false;
      }
    },
    displayBanner() {
      const footer = document.querySelector('.js-footer');
      const banner = document.querySelector('.js-banner');
      const clientRect = footer.getBoundingClientRect();
      const offset = clientRect.top - window.innerHeight;

      window.addEventListener('scroll', () => {
        let timeID;
        if (timeID != null) clearTimeout(timeID);

        timeID = setTimeout(() => {
          if (window.pageYOffset >= offset) {
            banner.classList.add('c-bannerFixed--passive');
          } else {
            banner.classList.remove('c-bannerFixed--passive');
          }
          timeID = null;
        }, 200);
      });
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
.u-reservation {
  position: absolute;
  top: 0;
  left: calc(-100% - 10px);
}
.c-info {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  &__content {
    width: calc(50% - 20px);
    margin-right: 20px;
  }
  &__action {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 50%;
  }
  &__actionButtonWrap {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    width: 100%;

    .c-button {
      width: calc(50% - 10px);
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  &__balloon {
    position: absolute;
    width:237px;
    z-index:10;
    right: 0;
  }
  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__mobileButton {
    display: none;
  }
  &__smallItem {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  &__head {
    padding: 8px 0;
    margin-right: 20px;
    border: 1px solid #cccccc;
    color: #666666;
    font-size: 14px;
    background: #fafafa;
    width: 88px;
    min-width: 88px;
    text-align: center;
  }
  &__data {
    color: #666666;
    font-size: 14px;
    line-height: 1.5;
    &__access {
      width:calc(100%  - 82px)
    }
    &__layout {
      width:calc(100%  - 96px)
    }
    &__area {
      width:calc(100%  - 110px)
    }
    &--big {
      font-size: 24px;
      font-weight: bold;
      color: #E83532;
    }
  }
  &__date {
    margin-top: 24px;
  }
  &__dateText {
    font-size: 12px;
    color: #666666;
    line-height: 1.5;
  }
}
.u-mT10 {
  margin-top: 10px;
}
.c-buttonFav {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 15px 34px;
  min-width: 228px;
  width: 100%;
  border: 1px solid #e83532;
  border-radius: 40px;
  color: #666666;
  font-size: 14px;
  word-break: keep-all;
  &--balloon {
    position:absolute;
    display:block;
    top: -50px;
    left: calc(50% - 121px);
    z-index: 111;
  }
  &--off {
    cursor: pointer;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 23px;
      margin-right: 10px;
      background-image: url(/static/img/favorite-selected.png);
      background-size: contain;
    }
  }
  &--on {
    background-color: #E83532;
    color: #FFF;
    cursor: pointer;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 23px;
      margin-right: 10px;
      background-image: url(/static/img/icon-favorite.png);
      background-size: contain;
    }
  }
}
.c-attention {
  margin:9px;
}
.c-pageTitle {
  display: flex;
  align-items: center;
  margin: 0;
  &__label {
    padding: 8px 16px;
    margin-right: 20px;
    color: #fff;
    font-size: 14px;
    background: #E83532;
    line-height: 1;
  }
  &__name {
    font-size: 18px;
    font-weight: bold;
    margin-right: 10px;
  }
}
.c-heading {
  padding: 13px 20px 15px;
  border-radius: 10px;
  color: #666666;
  font-size: 18px;
  font-weight: bold;
  background: #f6f6f6;
}
.c-section {
  margin: 30px 0 14px;
}
.c-imageArea {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
  &__item {
    width: calc(50% - 10px);
    height: 336px;
    object-fit: cover;
    &:first-of-type {
      margin-right: 10px;
    }
    &:last-of-type {
      margin-left: 10px;
    }
  }
}
.c-table {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  &__head {
    width: 160px;
    padding: 8px 10px;
    background: #fafafa;
    border-top: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    box-sizing: border-box;
    color: #666666;
    font-size: 13px;
  }
  &__data {
    width: calc(50% - 160px);
    padding: 8px 10px;
    border-top: 1px solid #cccccc;
    box-sizing: border-box;
    color: #666666;
    font-size: 13px;
    line-height: 1.5;
  }
}
.c-text {
  color: #666666;
  font-size: 14px;
  line-height: 1.7;
}
.c-slider {
  display: none;
}

.c-bannerFixed {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 22px 0;
  background: #FAFAFA;
  text-align: center;
  z-index: 100;
  transition: all 0.2s ease-out;

  &--passive {
    opacity: 0;
    transform: translateY(100%);
  }
}

.u-mT10 {
  margin-top: 10px;
}
.u-mB10 {
  margin-bottom: 10px;
}
.u-mB16 {
  margin-bottom: 16px;
}
@media screen and (max-width: 999px) {
  .c-buttonFav.u-mT10 {
    margin-top: 0;
  }
  .c-pageTitle {
    &__name {
      margin-top: 20px;
    }
  }
  .c-slider {
    display: block;
    margin-bottom: 20px;
    &__main {
      display: flex;
      align-items: center;
      overflow: scroll;
      position: relative;
    }
    &__arrow {
      position: absolute;
      top: 50%;
      width: 36px;
      height: 36px;
      border: 1px solid #cccccc;
      border-radius: 50%;
      background:rgba(255,255,255,0.8);
      // transform: translateY(-50%);
      &:before, &:after {
        position: absolute;
        top: calc(50% - 9px);
        left: calc(50% - 8px);
        content: "";
        display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url(/static/img/icon-arrow.png);
        background-size: contain;
      }
      &--prev {
        left: 10px;
        transform: rotate(180deg);
      }
      &--next {
        right: 10px;
      }
    }
    &__item {
        width: 100vh;
        object-fit: cover;
        &__img {
          min-width: 100%;
          height: 100%;
        }
    }
    &__thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
    &__thumbnailItem {
      padding: 6px;
      border: 1px solid #cccccc;
      &:first-child {
        margin-right: 4px;
      }
      &:last-child {
        margin-left: 4px;
      }
      &--active {
        border: 3px solid #E83532;
      }
    }
    &__thumbnailImage {
      width: 52px;
      height: 52px;
      object-fit: cover;
    }
  }
  .c-pageTitle {
    flex-wrap: wrap;
    &__label {
      padding: 4px 6px 6px;
      font-size: 12px;
    }
    &__name {
      width: 100%;
      margin-right: 0;
      text-align: left;
    }
  }
  .c-info {
    flex-wrap: wrap;
    &__content {
      width: 100%;
      margin-right: 0;
    }
    &__action {
      width: 100%;
      margin-top: 20px;
    }
    &__actionButtonWrap {
      display: block;

      .c-button {
        width: 100%;
        max-width: 320px;
        margin: 0 auto 10px;
      }
    }
    &__balloon {
      width: 100%;
      max-width: 320px;
      right: calc(50% - 160px);
      bottom: 44px;
    }
    &__item {
      margin-bottom: 8px;
    }
    &__smallItem {
      margin-right: 0;
      margin-bottom: 8px;
      width: 100%;
    }
    &__mobileButton {
      position: relative;
      display: block;
    }
    &__head {
      padding: 7px 10px;
      margin-right: 10px;
      width: 94px;
      border-radius: 4px;
      box-sizing: border-box;
    }
    &__data{
      width: calc(100% - 43%);
      &--big {
        font-size: 18px;
      }
    }
  }
  .c-table {
    &__head {
      width: 130px;
      line-height: 1.6;
    }
    &__data {
      width: calc(100% - 130px);
    }
  }

  .u-dPC {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .uWhite {
    background-color: #FFF;
  }
  .c-button--balloon {
    left: calc(50% - 146px);
  }
  .c-imageArea {
    display: none;
  }
  .c-bannerFixed {
    padding: 12px 10px;
    text-align: left;
    line-height: 1.5;
  }
}
</style>
